/**
 * Call saga index.
 * Defines which actions trigger which sagas.
 */

// Call plugin.
import { MAKE_ANONYMOUS_CALL, MAKE_CALL_FINISH, END_CALL_FINISH } from '../../interfaceNew/actionTypes'

// Other plugins.
import * as authActions from '../../../auth/interface/actions'

import { makeAnonymousCall } from './establish'

// Libraries.
import { takeEvery, take, put } from 'redux-saga/effects'

/**
 * Call operations.
 */

/**
 * Start an outgoing call.
 * @method makeAnonymousCallEntry
 * @param {Object} deps             Dependencies to be injected.
 * @param {Object} deps.webRTC      The WebRTC stack.
 */
export function * makeAnonymousCallEntry (deps) {
  // TODO: Using `makeCall` for now but will need a custom callstack saga for this
  yield takeEvery(MAKE_ANONYMOUS_CALL, makeAnonymousCall, { ...deps })
}

/**
 * Entry saga for handling the "end of call" operations.
 * @method anonymousCallEnd
 */
export function * anonymousCallEnd () {
  const failedMakeCallFinish = ({ type, error }) => type === MAKE_CALL_FINISH && error

  while (true) {
    yield take([END_CALL_FINISH, failedMakeCallFinish])

    // When the call ends, we want to disconnect the user.
    yield put(authActions.disconnect())
  }
}
